import axios from "./axiosConfig";

// Get all blogs
export const getBlogs = async () => {
  const response = await axios.get("/blogs/");
  return response.data;
};

// Get blog by slug
export const getBlogBySlug = async (slug) => {
  const response = await axios.get(`/blogs/${slug}/`);
  return response.data;
};
